import { render, staticRenderFns } from "./informCenter.vue?vue&type=template&id=dd3e11f2&scoped=true&"
import script from "./informCenter.vue?vue&type=script&lang=js&"
export * from "./informCenter.vue?vue&type=script&lang=js&"
import style0 from "./informCenter.vue?vue&type=style&index=0&id=dd3e11f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3e11f2",
  null
  
)

export default component.exports